// extracted by mini-css-extract-plugin
export default {"overlay":"CardOverlay_overlay__mrN1G"};